document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".testimonial-carousel-wrapper");

  wrappers.forEach(wrapper => {
    const slides = wrapper.querySelectorAll(".testimonial-slide");
    const dots = wrapper.querySelectorAll(".dot");
    const speed = parseInt(wrapper.dataset.speed || 6) * 1000;
    let currentIndex = 0;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.remove("active");
        dots[i].classList.remove("active");
      });
      slides[index].classList.add("active");
      dots[index].classList.add("active");
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }

    // Clickable dots
    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        currentIndex = parseInt(dot.dataset.index);
        showSlide(currentIndex);
      });
    });

    // Start autoplay
    setInterval(nextSlide, speed);
  });
});

